import { Injectable } from '@angular/core';
import { GenericResponse, GenericResponseData } from '../generic-response';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UserDataService } from '../user-repository/user-data.service';
import { UserRefreshTokenService } from '../user-repository/user-refresh-token.service';
import { baseUrl } from 'src/app/global-variables';
import {
  AddWeightResponse,
  GetWeightResponse,
  Weightlog,
} from 'src/app/core/model/api-response/weight-log-response-model';
import { WeightLogDataService } from './weight-log-data.service';
import { WebengageService } from '../analytics-repository/webengage.service';

@Injectable({
  providedIn: 'root',
})
export class WeightLogService {
  constructor(
    private http: HttpClient,
    private userDataService: UserDataService,
    private userRefreshTokenService: UserRefreshTokenService,
    private weightLogDataService: WeightLogDataService,
    private webengage: WebengageService
  ) {}

  addWeight(date: number, weight: number): Promise<GenericResponse> {
    let response: GenericResponse;
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .post<AddWeightResponse>(
        baseUrl + 'api/v2/weightlog',
        {
          date,
          weight,
        },
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then(async (res) => {
        // console.log('reeessss', res)
        if (res.success) {
          this.webengage.weightLogAdded(weight);
        }
        await this.weightLogDataService.addWeightLog(res.weightlog);
        response = new GenericResponse(res.success);
        return response;
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.addWeight(date, weight);
            }
          });
        }
        response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  updateWeight(weight: number, id: string): Promise<GenericResponse> {
    let response: GenericResponse;
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .patch<AddWeightResponse>(
        baseUrl + 'api/v2/weightlog/' + id,
        {
          weight,
        },
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then(async (res) => {
        // console.log('reeessss', res)
        if (res.success) {
          this.webengage.weightLogAdded(weight);
        }
        await this.weightLogDataService.updateWeightLog(weight, id);
        response = new GenericResponse(res.success);
        return response;
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.updateWeight(weight, id);
            }
          });
        }
        response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  async getWeight(): Promise<GenericResponse> {
    const startDate = 1000000000000;
    const endDate = 2000000000000;
    let response: GenericResponse;
    const weightlogsUpdatedAt = localStorage.getItem('weightlogsUpdatedAt');
    if (
      weightlogsUpdatedAt &&
      new Date().getTime() - new Date(weightlogsUpdatedAt).getTime() <
        30 * 60 * 1000
    ) {
      response = new GenericResponse(true);
      return response;
    }
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .get<GetWeightResponse>(
        baseUrl +
          'api/v2/weightlog?startDate=' +
          startDate +
          '&endDate=' +
          endDate,
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then(async (res) => {
        await this.weightLogDataService.saveWeightLogs(res.weightlogs);
        response = new GenericResponse(res.success);
        return response;
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.getWeight();
            }
          });
        }
        response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  async getCurrentWeight(): Promise<GenericResponse> {
    const weightlogApiResponse = await this.getWeight();
    if (weightlogApiResponse.isSuccess()) {
      const weightlogs = await this.weightLogDataService.getWeightLogs();
      const weightLog = weightlogs.weightlogs[0];
      return new GenericResponse(true, new GenericResponseData({ weightLog }));
    } else {
      return new GenericResponse(false);
    }
  }

  async getSelectedDayWeight(date: Date): Promise<GenericResponse> {
    const weightlogApiResponse = await this.getWeight();
    if (weightlogApiResponse.isSuccess()) {
      const weightLog = await this.weightLogDataService.getWeightLog(
        date.getTime()
      );
      return new GenericResponse(true, new GenericResponseData({ weightLog }));
    } else {
      return new GenericResponse(false);
    }
  }
  async getLastWeight(date: Date) {
    const weightLog = await this.weightLogDataService.getLastWeightLog(
      date.getTime()
    );
    return weightLog;
  }
}
